<template>
  <div class="ratio ratio-16x9">
    <iframe
      class="embed-responsive-item"
      :src="url"
      loading="lazy"
      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
      allowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: ['url'],
}
</script>
